import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';
import styles from './expandButton.scss';

const ExpandButton = ({ collapsed, onClick, name }) => (
  <TextLink
    className={classNames(styles.expandButton, collapsed ? styles.show : styles.hide)}
    underline="always"
    iconRight
    onClick={onClick}
    component="button"
  >
    {`${collapsed ? 'Show' : 'Hide'}${name ? ` ${name}` : ''}`}
  </TextLink>
);

ExpandButton.displayName = 'ExpandButton';
ExpandButton.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  name: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

ExpandButton.defaultProps = {
  name: '',
};

export default ExpandButton;
